module.exports = __webpack_public_path__ + "static/media/error_background.f5c3ea7e.svg";